// extracted by mini-css-extract-plugin
module.exports = {"container":"Main_container__2QrCT"};